<template>
  <div>
    <section-title
      content="Información de Contacto Primario"
      :has-line="true"
    />
    <location-service-contact-row
      v-for="(contact, idx) in primaryContact"
      :key="`type-${idx}`"
      :contact="contact"
      :location-id="locationId"
      @reload="$emit('reload')"
    />
    <location-service-contact-row
      v-for="(contact, idx) in listWithoutPrimaryContact"
      :key="`types-${idx}`"
      :contact="contact"
      :location-id="locationId"
      @reload="$emit('reload')"
    />
    <div v-if="items.length == 0" class="bg-secondary-3 rounded p-4 px-5">
      <custom-result-not-found
        :text="'No cuenta con la información contacto en sistema.'"
      />
    </div>
  </div>
</template>

<script>
import SectionTitle from 'SectionTitle';
import CustomResultNotFound from 'custom-result-not-found';
import LocationServiceContactRow from './LocationServiceContactRow';

export default {
  name: 'LocationServiceContacts',
  components: {
    SectionTitle,
    CustomResultNotFound,
    LocationServiceContactRow,
  },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    locationId: {
      type: Number,
      default: () => 0,
    },
  },
  data() {
    return {};
  },
  computed: {
    headerConfig() {
      return {
        icon: 'fas fa-phone fa-flip-horizontal custom-lsci-header-icon p-0 m-0',
        title: 'Información de Contacto Primario',
      };
    },
    actionItems() {
      return (item) => {
        return [
          {
            label: 'Editar',
            icon: 'fas fa-edit color-green',
            border: item.isPrimaryContactFlag ? '' : 'bottom',
            click: () => this.$emit('on-edit-contact', item),
          },
          {
            label: 'Eliminar',
            icon: 'fas fa-times-circle color-red',
            visible: !item.isPrimaryContactFlag,
            click: () => this.$emit('on-delete-contact', item),
          },
        ];
      };
    },
    primaryContact() {
      return this.items?.filter((item) => item.isPrimaryContactFlag);
    },
    listWithoutPrimaryContact() {
      return this.items?.filter((item) => !item.isPrimaryContactFlag);
    },
  },
  filters: {
    formatPhone(phone) {
      if (phone?.trim() > 0) {
        return (
          '(' +
          phone.substring(0, 3) +
          ') ' +
          phone.substring(3, 6) +
          '-' +
          phone.substring(6)
        );
      } else {
        return phone?.trim().length === 0 ? '-' : phone;
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import '~@/shared/scss/config/colors.scss';
.dot {
  background-color: map-get($colors, 'orange');
  box-shadow: 0px 3px 6px #00000029;
  margin: 2px;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border-style: solid;
  border-width: 3px;
  border-color: map-get($colors, 'white');
  display: inline-block;
}
.ml-2-5 {
  margin-left: 2.5rem;
}
.mln-1-5 {
  margin-left: -1.5rem;
}
.mr-n6 {
  margin: 0 -6rem;
}
</style>
